export default __webpack_public_path__ + "static/cities-236bb1155c9118f98448b40611955528.svg";